export default {"src":"/_next/static/media/gpu.62926c7e.svg","height":24,"width":24};